import { createBaseFilter } from "@circle-react-shared/MemberFilters/types";

import { toQueryString } from "./toQueryString";

interface SpaceSlug {
  spaceSlug?: string;
}

export const spacePaths = {
  members: ({ spaceSlug }: SpaceSlug) =>
    `/members?${toQueryString({
      filters: [
        createBaseFilter({
          id: "spaces",
          key: "spaces",
          value: spaceSlug,
        }),
      ],
    })}`,
};
